export default function DocumentItem({ doc, onDownload }) {
    return (
        <div className="card-body">
            <div className="row">
                <div className="col-6 col-md mb-3 mb-md-0">
                    <small className="card-subtitle mb-0">{doc.text}</small>
                </div>
                <div className="col-6 col-md">
                    <small className="card-subtitle mb-0">{doc.type}</small>
                </div>
                <div className="col-6 col-md">
                    <small className="card-subtitle mb-0">{doc.created_at}</small>
                </div>
                <div className="col-6 col-md mb-3 mb-md-0">
                    <small className="card-subtitle mb-0">
                        <button className="btn btn-sm btn-outline-primary" onClick={() => onDownload(doc)} disabled={doc.downloading}>
                            Descargar
                        </button>
                    </small>
                </div>
            </div>
        </div>
    );
}
